export enum ManageGroupType
{
    VIEW, EDIT, CREATE, LIST
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/managegrouptype.ts